(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["capoo-explore-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('capoo-explore')) {
  customElements.define('capoo-explore', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.opener = document.querySelector(`[data-capoo-menu-open][aria-controls="${this.dialog.id}"]`);
      if (!this.opener || !this.dialog.showModal) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.opener.addEventListener('click', event => { event.preventDefault(); this.dialog.showModal(); this.opener.setAttribute('aria-expanded', 'true'); document.documentElement.classList.add('capoo-explore-open'); this.querySelector('[data-capoo-menu-close]').focus(); }, options);
      this.querySelector('[data-capoo-menu-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => { if(event.target === this.dialog) { const bounds = this.dialog.getBoundingClientRect(); if(event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close(); } }, options);
      this.dialog.addEventListener('close', () => { this.opener.setAttribute('aria-expanded','false'); document.documentElement.classList.remove('capoo-explore-open'); this.dialog.classList.remove('is-drilled'); this.opener.focus(); }, options);
      this.querySelectorAll('[data-capoo-panel]').forEach(button => button.addEventListener('click', () => { const panel = button.dataset.capooPanel; this.querySelectorAll('[data-capoo-panel]').forEach(item => { const active = item === button; item.classList.toggle('is-active',active); item.setAttribute('aria-expanded',String(active)); }); this.querySelectorAll('[data-capoo-panel-content]').forEach(item => { item.hidden = item.dataset.capooPanelContent !== panel; }); this.dialog.classList.add('is-drilled'); this.querySelector('.capoo-explore__gallery').scrollTop = 0; if(matchMedia('(max-width:749px)').matches) this.querySelector('[data-capoo-menu-back]').focus(); }, options));
      this.querySelector('[data-capoo-menu-back]').addEventListener('click', () => { this.dialog.classList.remove('is-drilled'); this.querySelector('.capoo-explore__nav.is-active').focus(); }, options);
      this.querySelectorAll('a').forEach(link => link.addEventListener('click', () => this.dialog.close(), options));
    }
    disconnectedCallback() { this.abort?.abort(); document.documentElement.classList.remove('capoo-explore-open'); this.ready = false; }
  });
}
  } catch(e) { console.error(e); }
})();

})();
